module.exports = __webpack_public_path__ + "img/2.570af9a2.jpg";